import { Component, Input, OnInit } from '@angular/core'
import * as moment from 'moment'
import { Utils } from '../../../common/utils/utils'
import { TimesheetDayRep } from '../model/timesheet-day-rep.model'

@Component({
    selector: 'ppw-day-representation-row',
    templateUrl: './day-representation-row.component.html',
    styleUrls: ['./day-representation-row.component.scss']
})
export class DayRepresentationRowComponent implements OnInit {
    @Input() dayRep!: TimesheetDayRep
    @Input() isLast!: boolean

    trackBy = Utils.trackByIndex
    dateAsString?: string
    isWeekend?: boolean
    last?: boolean

    ngOnInit(): void {
        if (this.dayRep) {
            const mmdd = this.dayRep.moment.format('MMDD')
            const yymmdd = this.dayRep.moment.format('YYMMDD')
            this.dateAsString = this.dayRep.moment.format('ddd DD/MM/YYYY')
            this.isWeekend = this.dayRep.moment.weekday() === 6 || this.dayRep.moment.weekday() === 0
            this.isWeekend =
                this.isWeekend || ['0101', '0501', '0721', '0815', '1101', '1111', '1225'].indexOf(mmdd) > -1
            this.isWeekend =
                this.isWeekend ||
                [
                    '200413',
                    '200521',
                    '200601',
                    '210405',
                    '210513',
                    '210524',
                    '220418',
                    '220526',
                    '220606',
                    '230410',
                    '230518',
                    '230529',
                    '240401',
                    '240509',
                    '240520',
                    '250421',
                    '250529',
                    '250609',
                    '260406',
                    '260514',
                    '260525',
                    '270329',
                    '270506',
                    '270517',
                    '280417',
                    '280525',
                    '280605',
                    '290402',
                    '290510',
                    '290521'
                ].indexOf(yymmdd) > -1
            this.setLast()
        }
    }

    private setLast(): void {
        const momentCopy = moment(this.dayRep.moment)
        this.last = this.dayRep.moment.get('date') === momentCopy.endOf('month').get('date')
    }
}
